<style lang="stylus">
    .promotion-box
        position absolute
        width 156px
        height 208px
        padding 16px
        background #FFFFFF
        border 0.5px solid rgba(0, 0, 0, 0.06)
        box-shadow 0px 100px 80px rgba(0, 0, 0, 0.03), 0px 22.3363px 17.869px rgba(0, 0, 0, 0.0178832), 0px 6.6501px 5.32008px rgba(0, 0, 0, 0.0121168)
        border-radius 8px
        z-index 10
        .promotion-box-img
            display block
            width 124px
            height 124px
            margin-bottom 16px
            border-radius 6px
        p
            width 100%
            text-align center
            line-height 16px
        .promotion-box-title
            font-size 12px
            color #222222
            margin-bottom 4px
            font-weight 600
        .promotion-box-text
            font-size 12px
            transform scale(0.83)
            color rgba(34, 34, 34, 0.7)

        &.dark-theme__promotion
            background #3f3f41
            border 0.5px solid rgba(255, 255, 255, 0.1)
            .promotion-box-title
                color #fff
            .promotion-box-text
                color rgba(255, 255, 255, 0.7)
</style>

<template>
    <div
        class="promotion-box"
        :class="{ 'dark-theme__promotion': isPCDarkMode == 2 }"
        ref="box"
        v-show="showPromotionBox"
        :style="`left: ${left}px; top: ${top}px`"
    >
        <img class="promotion-box-img" :src="img" alt="" />
        <p class="promotion-box-title">{{ title }}</p>
        <p class="promotion-box-text">{{ text }}</p>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue } from "vue-property-decorator";

    @Component({
        components: {},
    })
    export default class MiniProgram extends Vue {
        width = 0;
        height = 0;

        get img() {
            if (this.boxType == "app") return require("@/home/assets/img/downloadpage.png");
            else if (this.boxType == "mini") return require("@/home/assets/img/miniprogram/miniprogram.jpg");
            else return null;
        }
        get title() {
            if (this.boxType == "app") return this.$t("download");
            else if (this.boxType == "mini") return this.$t("wx");
            else return null;
        }
        get text() {
            if (this.boxType == "app") return this.$t("support");
            else if (this.boxType == "mini") return this.$t("desc");
            else return null;
        }
        get boxType() {
            return this.$store.state.promotionBox.type;
        }
        get showPromotionBox() {
            return this.$store.state.showPromotionBox;
        }
        get left() {
            return this.$store.state.promotionBox.left + (this.direction & 2 ? -this.width - 10 : 0);
        }
        get top() {
            return this.$store.state.promotionBox.top + (this.direction & 1 ? -this.height - 10 : 0);
        }
        get direction() {
            return this.$store.state.promotionBox.direction;
        }
        mounted() {
            let target = getComputedStyle(this.$refs.box as HTMLElement);
            this.width = (target.width as any).replace(/[^\d]/g, "") - 0;
            this.height = (target.height as any).replace(/[^\d]/g, "") - 0;
        }

        created() {}
    }
</script>
<i18n>
    {
        "zh": {
            "download": "下载App",
            "wx": "微信扫码打开小程序",
            "support": "支持Android&iOS",
            "desc": "随时随地查看个人文件"
        },
        "en": {
            "download": "Download APP",
            "wx": "Scan the WeChat code to open the mini program",
            "support": "Support Android & iOS",
            "desc": "View personal files anytime, anywhere"
        }
    }
</i18n>
